import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import PointSelectionLine from './PointSelectionLine';
import PointSelectionDot from './PointSelectionDot';

export default function PointSelectionDotsAndLines(props) {
  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();

  const [selectedDot, setSelectedDot] = useState(props.selectedDot);

  const dotSelect = ix => {
    setSelectedDot(ix);
    if (props.onSelect) {
      props.onSelect(ix);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container direction="row" justify="center" alignItems="center">
        {/*empty item, just occupying space */}
        <Grid item>
          <div style={{ width: '22px', height: '1px' }} />
        </Grid>
        <Grid item>
          <div onClick={() => dotSelect(0)}>
            <PointSelectionDot
              selected={selectedDot === 0}
              color={props.color}
              tag={`${props.tag}-0`}
            />
          </div>
        </Grid>
        <Grid item>
          <PointSelectionLine color={props.color} />
        </Grid>
        <Grid item>
          <div onClick={() => dotSelect(1)}>
            <PointSelectionDot
              selected={selectedDot === 1}
              color={props.color}
              tag={`${props.tag}-1`}
            />
          </div>
        </Grid>
        <Grid item>
          <PointSelectionLine color={props.color} />
        </Grid>
        <Grid item>
          <div onClick={() => dotSelect(2)}>
            <PointSelectionDot
              selected={selectedDot === 2}
              color={props.color}
              tag={`${props.tag}-2`}
            />
          </div>
        </Grid>
        <Grid item>
          <PointSelectionLine color={props.color} />
        </Grid>
        <Grid item>
          <div onClick={() => dotSelect(3)}>
            <PointSelectionDot
              selected={selectedDot === 3}
              color={props.color}
              tag={`${props.tag}-3`}
            />
          </div>
        </Grid>
        <Grid item>
          <PointSelectionLine color={props.color} />
        </Grid>
        <Grid item>
          <div onClick={() => dotSelect(4)}>
            <PointSelectionDot
              selected={selectedDot === 4}
              color={props.color}
              tag={`${props.tag}-4`}
            />
          </div>
        </Grid>
        {/*empty item, just occupying space */}
        <Grid item>
          <div style={{ width: '22px', height: '1px' }} />
        </Grid>
      </Grid>
    </div>
  );
}
